import { CategorySchema } from "@/components/_Shared/Form/Schemas/Category";
import { AssignedBySchema, AssignedToSchema } from "@/components/_Shared/Form/Schemas/ManagerSchema";
import { ProjectSchemaOptional } from "@/components/_Shared/Form/Schemas/ProjectSchema";
import { StatusSchema } from "@/components/_Shared/Form/Schemas/StatusSchema";
import { z } from "zod";


export const baseFormSchema = z.object({
  task_id: z.string().optional(),
  title: z.string().min(1, { message: "Title is required" }),
  description: z.string().optional(),
  completion_percentage: z.number().min(0, { message: "Completion percentage must be greater than 0" }).max(100, { message: "Completion percentage must be less than 100" }),
  due_date: z.string().min(1, { message: "Due date is required" }),
  priority: z.boolean(),
})
  .merge(AssignedBySchema)
  .merge(ProjectSchemaOptional)
  .merge(AssignedToSchema)
  .merge(CategorySchema)
  .merge(StatusSchema);
